import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import { getOrganisationId } from "../organisations/organisationsSlice";
import { fetchNotifications } from "./notificationsAPI";
import { catchAllErrors } from "../../hoc/catchAllErrors";

export const fetchNotificationsAsync = createAsyncThunk("notifications/fetchNotifications", async () => {
    try {
        const orgId = await catchAllErrors(getOrganisationId)();
        const response = await catchAllErrors(fetchNotifications)(orgId);
        return response;
    } catch (error) {
        const isUnauthorized = error.message === "Unauthorized";
        toast("Failed to fetch notifications", { type: "error" });
        console.log(error);
        throw error;
    }
});

const initialState = {
    notifications: [],
    status: "idle",
    error: null,
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        addNotification: (state, action) => {
            state.notifications.push(action.payload);
        },
        removeNotification: (state, action) => {
            state.notifications = state.notifications.filter((notification) => notification.id !== action.payload);
        },
        clearNotifications: (state) => {
            state.notifications = [];
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchNotificationsAsync.fulfilled, (state, action) => {
            state.notifications = action.payload;
            state.status = "fulfilled";
        })
        .addCase(fetchNotificationsAsync.rejected, (state, action) => {
            state.notifications = [];
            state.status = "rejected";
            state.error = action.error.message;
        })
        .addCase(fetchNotificationsAsync.pending, (state, action) => {
            state.notifications = [];
            state.status = "pending";
        });
    },
});

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions;

export default notificationsSlice.reducer;
